// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"r_D","menu":"r_F"};